import { useEffect } from "react";
import { useNavigate } from "react-router";
import { useSession } from "@/api/onboarding";
import { handleAccessError } from "@/auth/access";
import { currentTenant, setCurrentTenant } from "@/auth/session";

/**
 * Before the workspace opens: who is signed in, and which of their tenants to show. A person
 * in no tenant goes to the no-access screen; a superadmin in none, to the platform console.
 */
export function useWorkspace(): boolean {
  const session = useSession();
  const navigate = useNavigate();
  const data = session.data;
  const ready = Boolean(data?.tenants.length);

  // Settled before anything below asks the API, so every request names a tenant they're in.
  if (data && ready) {
    const stored = currentTenant();
    if (!stored || !data.tenants.some((t) => t.slug === stored)) {
      setCurrentTenant(data.tenants[0]?.slug ?? null);
    }
  }

  useEffect(() => {
    if (session.isError) {
      handleAccessError(session.error);
      return;
    }
    if (data && !data.tenants.length) {
      void navigate(data.is_superadmin ? "/platform" : "/no-access?code=no_tenant", {
        replace: true,
      });
    }
  }, [data, session.isError, session.error, navigate]);

  return ready;
}
